/* eslint-disable react/jsx-key */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
  Avatar, Badge, Tooltip,
} from 'antd';
import Helpers from '@Apis/helpers';
import { CSS } from '@dnd-kit/utilities';

import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIndustry, faWrench } from '@fortawesome/free-solid-svg-icons';
import { LoadingOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Progress from '@Components/Common/H3Progress';

const getStatusColor = (status) => {
  if (status === 'COMPLETED') return { color: '#22C55EFF', text: 'Completed' };
  if (status === 'DRAFT') return { color: '#b0b0b0', text: 'Draft' };
  if (status === 'IN_PROGRESS') return { color: '#2d7cf7', text: 'In Progress' };
  if (status === 'PENDING') return { color: '#dcb106', text: 'Pending' };
  if (status === 'PAUSED') return { color: '#b0b0b0', text: 'Paused' };
  if (status === 'VOID') return { color: '#d2d2d2', text: 'Void' };
};

// Column
export const SectionItem = (props) => {
  const {
    id, items, name, data, isSortingContainer, dragOverlay, user, groupBy, getJobWorksKanbanPage, bottomLoading, groupName, loading, count, setSelectedJobWork,
  } = props;
  const {
    // active,
    attributes,
    isDragging,
    listeners,
    // over,
    setNodeRef,
    setActivatorNodeRef,
    transition,
    transform,
  } = useSortable({
    id,
    data: {
      type: 'SECTION',
    },
  });

  const getColumnHeight = () => {
    const h = document.getElementsByClassName('kanban-column')[0].clientHeight;
    return h;
  };

  const style = {
    transform: CSS.Translate.toString(transform),
    height: dragOverlay ? `${`${getColumnHeight() }px`}` : null,
    transition,
    opacity: isDragging ? 0.5 : 1,
    boxShadow: dragOverlay
      ? '0 0 0 calc(1px / 1) rgba(63, 63, 68, 0.05), -1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)'
      : '',
    border: dragOverlay
      ? '1px solid rgba(64, 150, 255, 1)'
      : '1px solid #dcdcdc',
    touchAction:
            'ontouchstart' in window
            || navigator.MaxTouchPoints > 0
            || navigator.msMaxTouchPoints > 0
              ? 'manipulation'
              : 'none',
  };

  return (
    <div
      ref={setNodeRef}
      className="kanban-column"
      style={style}
    >
      <div
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        className="kanban-column-header"
        style={{
          cursor: dragOverlay ? 'grabbing' : 'grab',
        }}
      >

        <div className="kanban-column-header__text">
          {groupBy !== 'work_center' ? name?.split('#')?.[0] : name}
        </div>
        {(bottomLoading) && <LoadingOutlined className="kanban-column-header__loader" />}
        <Badge
          count={count || 0}
          showZero
          style={{
            backgroundColor: '#fff',
            color: '#000',
            marginLeft: '10px',
          }}
        />
      </div>
      <div className="kanban-column-list">

        <SortableContext
          items={items}
          strategy={verticalListSortingStrategy}
        >
          {items.map((item, _index) => (
            <div onClick={() => setSelectedJobWork(data.filter((d) => `task-${ d.id}` === item)[0]?.production_route_line_id)}>
              <FieldItem
                id={item}
                key={item}
                item={data.filter((d) => `task-${ d.id}` === item)[0]}
                disabled={isSortingContainer}
                user={user}
              />
            </div>
          ))}
          {items?.length < Number(count) && (
            <div
              className="kanban-column-list__load-more"
              onClick={() => {
                getJobWorksKanbanPage({
                  groupBy,
                  groupId: id,
                  scrollType: 'BOTTOM',
                });
              }}
            >
              {bottomLoading ? 'Loading..' : 'Load More..'}
            </div>
          )}
        </SortableContext>
      </div>
    </div>
  );
};

// Task
export const FieldItem = (props) => {
  const {
    id, item, dragOverlay, user,
  } = props;

  function convertMinutesToTime(minutes) {
    if (Number.isNaN(minutes) || minutes < 0) {
      return 'Invalid input';
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const seconds = Math.round((minutes % 1) * 60);

    const formattedHours = hours > 0 ? (hours < 10 ? `0${hours}` : hours) : '00';
    const formattedMinutes = remainingMinutes > 0 ? (remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes) : '00';
    const formattedSeconds = seconds > 0 ? (seconds < 10 ? `0${seconds}` : seconds) : '00';

    return `${formattedHours }:${ formattedMinutes }:${ formattedSeconds}`;
  }

  const {
    setNodeRef,
    // setActivatorNodeRef,
    listeners,
    isDragging,
    // isSorting,
    // over,
    // overIndex,
    transform,
    transition,
    attributes,
  } = useSortable({
    id,
    disabled: props.disabled,
    data: {
      type: 'FIELD',
    },
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    boxShadow: dragOverlay
      ? '0 0 0 calc(1px / 1) rgba(63, 63, 68, 0.05), -1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)'
      : '',
    border: dragOverlay
      ? '1px solid rgba(64, 150, 255, 1)'
      : '1px solid #dcdcdc', // 1px solid rgba(64, 150, 255, 1)
    cursor: dragOverlay ? 'grabbing' : 'grab',
    // transform: dragOverlay ? 'rotate(0deg) scale(1.02)' : 'rotate(0deg) scale(1.0)'
    touchAction:
            window.PointerEvent
            || 'ontouchstart' in window
            || navigator.MaxTouchPoints > 0
            || navigator.msMaxTouchPoints > 0
              ? 'manipulation'
              : 'none',
  };

  /**
   *
   * @param rec
   * @returns {number}
   */
  const getCompletion = (rec) => {
    const total = Number(rec?.pending_qty || 0)
        + Number(rec?.completed_qty || 0)
        + Number(rec?.rework_qty || 0)
        + Number(rec?.rejected_qty || 0);
    const completed = Number(rec?.completed_qty || 0) + Number(rec?.rejected_qty || 0);
    return (completed / total) * 100;
  };
  return (
    <div
      ref={props.disabled ? null : setNodeRef}
      className="kanban-column-card"
      style={style}
      {...attributes}
      {...listeners}
    >
      <div>
        <div className="flex-display">
          <div style={{ fontSize: '12px' }}>
            {item?.jw_number || ''}
          </div>
          {(item?.incomplete_previous_job_works?.length > 0) || (item?.rm_lines?.filter((items) => items?.issued_rm_qty === 0)?.length > 0) ? (
            <div className="kanban-card__status" style={{ backgroundColor: item?.status === 'PENDING' ? 'rgb(241, 100, 110)' : getStatusColor(item?.status).color, marginLeft: 'auto', fontSize: '10px' }}>
              { item?.status === 'PENDING' ? 'BLOCKED' : getStatusColor(item?.status).text?.toUpperCase()}
            </div>
          ) : (
            <div className="kanban-card__status" style={{ backgroundColor: getStatusColor(item?.status).color, marginLeft: 'auto', fontSize: '10px' }}>
              {getStatusColor(item?.status).text?.toUpperCase()}
            </div>
          )}
        </div>
        {Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user) && (
          <div className="table-subscript" style={{ fontWeight: '600', marginTop: '5px' }}>
            {item?.mo_number}
          </div>
        )}
        <div style={{ marginTop: '15px' }}>
          {item?.machine_resource_group?.allocated_machine?.resource_name && (
            <div className="kanban-card__info">
              <FontAwesomeIcon icon={faIndustry} />
           &nbsp;
              <div className="kanban-card__info-machine-name">{item?.machine_resource_group?.allocated_machine?.resource_name}</div>
            </div>
          )}
          <div style={{ marginTop: '7px' }} className="kanban-card__info">
            <FontAwesomeIcon icon={faWrench} />
            &nbsp;
            {item?.process_name}
          </div>
          <div className="kanban-card__info kanban-card__product-name">
            {`${item?.internal_sku_code} - ${item?.product_sku_name}`}
          </div>
          {item?.mo_adjustment_id && <H3Text text={`Batch #${item?.fg_adjustment?.custom_batch_number}`} className="kanban-card__batch-name" />}
          {item?.lead_time_in_min && <H3Text text={`Est. Lead Time ${convertMinutesToTime(item?.lead_time_in_min)}`} className="kanban-card__batch-name" />}
        </div>
        <div style={{ marginTop: '10px' }}>
          {item?.mo_adjustment_id && (
            <H3Progress
              percent={parseInt(getCompletion(item))}
              barWidth="100%"
            />
          )}
        </div>
        <div className="kanban-card__footer">
          <div className="kanban-card__quantity">
            {`${item?.target_quantity} ${item?.fg_uom_info?.uqc ? item?.fg_uom_info?.uqc?.toProperCase() : item?.sfg_uom_info?.uqc?.toProperCase()}`}
          </div>
          {item?.assignees?.length > 0 && (
            <Avatar.Group
              size="small"
              maxStyle={{
                color: '#fff',
                backgroundColor: '#ccc',
              }}
            >
              {item.assignees.map((item) => (
                <Tooltip title={item?.first_name}>
                  <Avatar key={item?.user_id} style={{ backgroundColor: Helpers.getAvatarColors(item?.identity?.[0])?.color1 }}>
                    {item?.identity?.toUpperCase()}
                  </Avatar>
                </Tooltip>
              ))}
            </Avatar.Group>
          )}
        </div>
      </div>
    </div>
  );
};
